import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { ALL, EMPTY_STRING, GET_GEN_TASK_URL, PAGE_SIZE } from '../common/constants';
import { formatDate, isEmpty, isEmptyArray } from '../common/util.services';
import './task.scss';
import { getGeneralTask, deleteGeneralTask, saveTaskComments } from './task.services';
import SearchPanel from '../../components/search-panel/search-panel.component';
import { Box, Grid, Tooltip } from '@mui/material';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';
import { useNavigate } from 'react-router-dom';
import IDialogComponent from '../../components/dialog/i-dialog.component';
import TextComponent from '../enquiry/enq-product/edit-text.component';

const GeneralTaskList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const [openComment, setOpenComment] = useState(false);
  const [cellTitle, setCellTitle] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState(null);
  const rows: GridRowsProp = [];
  const [taskData, setTaskData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({taskOwner: isEmpty(localStorage.getItem('searchData')) ? ALL : 
                                                     JSON.parse(localStorage.getItem('searchData') ?? '').taskOwner,
                                                     priority: isEmpty(localStorage.getItem('searchData')) ? ALL : 
                                                     JSON.parse(localStorage.getItem('searchData') ?? '').priority, 
                                                     status: isEmpty(localStorage.getItem('searchData')) ? ALL : 
                                                     JSON.parse(localStorage.getItem('searchData') ?? '').status});
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'taskOwner', headerName: 'Owner', filterable: false, sortable: false, editable: false, width: 110},
    { field: 'task', headerName: 'Task', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'taskCreator', headerName: 'Task Creator', filterable: false, sortable: false, editable: false, width: 110},
    { field: 'creationDate', headerName: 'Creation', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'priority', headerName: 'Priority', filterable: false, sortable: false, editable: false, width: 75,
      cellClassName: (params) => { return params.row.priority}
    },
    { field: 'targetDate', headerName: 'Target', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => formatDate(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.targetHistory)}
      PopperProps={popperProps}>{<Box>{formatDate(params.row.targetDate)}</Box>}</Tooltip>)
    },
    { field: 'completionDate', headerName: 'Completion', filterable: false, sortable: false, editable: false, width: 95,
      renderCell: (params: any) => ('Completed' !== params.row.status ? 'NA' : formatDate(params.row.completionDate))
    },
    { field: 'daysDiff', headerName: 'Diff', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value,
      cellClassName: (params) => { return isEmpty(params.row.daysDiff) ? '' : params.row.daysDiff >= 0 ? 'DiffP' : 'DiffN'}
    },
    { field: 'ageing', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value
    },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value,
      cellClassName: (params) => { return isEmpty(params.row.daysLeft) || params.row.daysLeft >= 0 ? '' : 'DiffN'}
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 95,
      cellClassName: (params) => { return params.row.status}
    },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 100 },
    { field: 'comments', headerName: 'Comments', filterable: false, sortable: false, editable: false, width: 120 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      localStorage.setItem('searchData', JSON.stringify({taskOwner: ALL, priority: ALL, status: ALL}));
      searchData.myTask = false;
      getGeneralTask(searchData, page, pageSize, appContext,
        (response: any) => {
          setTaskData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  function getTooltip(target: string[]) {
    let array: any[] = ['History:'];
    if(isEmptyArray(target)) {
      array.push('NA')
    }
    for(let i = 0; i < target.length; ++i) {
      array.push(target[i]);
    }

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  const search = (data: any) => {
    setSearchData(data);
  }

  const addTask = () => {
    localStorage.setItem('searchData', JSON.stringify(searchData));
    navigate('new');
  }

  const handleDoubleClick = (value: any) => {
    if('comments' === value.field && 'LFHADMIN' === appContext.userData.role) {
      setCellLabel('Task Comments');
      setCellTitle('Specify Comments');
      setCellValueRow(value.row);
      setOpenComment(true);
    }
  }

  const closeCommentPopup = (value: any) => {
    if('Ok' === value) {
      saveTaskComments(cellValueRow, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
    setOpenComment(false);
  }

  const editTask = (row: any) => {
    if(row.createdBy !== appContext.userData.rowId) {
      appContext.setDialogMessage('Only task creator can edit the task.');
    } else {
      localStorage.setItem('searchData', JSON.stringify(searchData));
      navigate(EMPTY_STRING + row.rowId);
    }
  }

  const deleteTask = (row: any) => {
    deleteGeneralTask(row.rowId, appContext,
      (response: any) => {
        navigate(0);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={4}>
          <IDropdown name='taskOwner' label='Task Owner' url={GET_GEN_TASK_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={4}>
          <IDropdown name='priority' label='Priority' itemList={['Low', 'Medium', 'High']} allItemRequired={true} />
        </Grid>
        <Grid xs={4}>
          <IDropdown name='status' label='Status' itemList={['Completed', 'Pending']} allItemRequired={true} />
        </Grid>
      </Grid></SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={taskData} columns={columns} loading={loading} maxHeight={500}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        getRowId={(row: any) => row.rowId} showAction={true} showApproveAction={false} cellDoubleClick={handleDoubleClick}
        handleEditAction={editTask} showAddBtn={true} addRow={addTask} handleDeleteAction={deleteTask}/>
      <IDialogComponent onClose={closeCommentPopup} open={openComment} title={cellTitle}
        dialogBody={<TextComponent data={cellValueRow} close={closeCommentPopup} label={cellLabel} multiline={true}/>} />
    </>
  }

  return <TitlePanel title={'Manage Task'} panelBody={getMainPanel()} />
}

export default GeneralTaskList;